import React, { useState } from 'react';
import styled from 'styled-components';
import { ethers } from 'ethers';
import { Button, Modal, Form, Input, Message } from 'semantic-ui-react';
import SocialVaultContract from '../artifacts/contracts/SocialVault.sol/SocialVault.json';
import { useNavigate } from 'react-router-dom';

interface INFTCardProps {
  address: string;
  stakedAmount: string;
  targetAmount: string;
  url: string;
  name: string;
}

const NFTCard = (props: INFTCardProps): JSX.Element => {
  const [contribution, setContribution] = useState<string>('0');
  const [open, setOpen] = useState<boolean>(false);
  const [addressToStake, setAddressToStake] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const ethStaked = ethers.utils.formatEther(props.stakedAmount);
  const ethAmount = ethers.utils.formatEther(props.targetAmount);

  const navigate = useNavigate();
  const handleHistory = (address: string) => {
    navigate(`/buy/${address}`);
  }

  function bringUpModal(address: string) {
    setErrorMessage('');
    setAddressToStake(address);
    setOpen(true);
  }

  async function stake() {
    try {
      setLoading(true);
      const provider: any = new ethers.providers.Web3Provider((window as any).ethereum);
      const userSocialVault: any = new ethers.Contract(
        addressToStake,
        SocialVaultContract.abi,
        provider.getSigner(0)
      );

      const overrides = {
        value: ethers.utils.parseEther(contribution),
      }

      await userSocialVault.stakeAmount(overrides);
    } catch (e) {
      setErrorMessage((e as Error).message);
    } finally {
      setLoading(false);
      setOpen(false);
    }
  }

  return(
    <>
    <CardDiv>
      <ColumnOne>
          <img style={{width: "38px"}} src={props.url}/>
        </ColumnOne>
        <ColumnTwo>
          { props.name }
        </ColumnTwo>
        <ColumnEight>
          { `${ethStaked} / ${ethAmount} ETH` }
        </ColumnEight>
        <ColumnOne>
          <p style={{fontWeight: "bold", cursor: "pointer", display:"inline-block"}} onClick={() => bringUpModal(props.address)}>fund /&nbsp;</p>
          <p style={{fontWeight: "bold", cursor: "pointer", display:"inline-block"}} onClick={() => handleHistory(props.address)}>buy</p>
        </ColumnOne>
    </CardDiv>
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
    >
      <Modal.Header>How much would you like to stake?</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Form error={!!errorMessage}>
          <Form.Field>
            <label>Target Amount</label>
            <Input
                label="eth"
                labelPosition="right"
                value={contribution}
                onChange={event => setContribution(event.target.value )}
            />
            </Form.Field>
            <Message error header="Oops!" content={errorMessage} />
          </Form>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button color='black' onClick={() => setOpen(false)}>
          Cancel
        </Button>
        <Button
          content="Stake"
          labelPosition='right'
          icon='checkmark'
          onClick={() => stake()}
          positive
          loading={loading}
        />
      </Modal.Actions>
    </Modal>
    </>
  )
}

export const ColumnOne = styled.div`
  background: #DCDCDC;
  display: inline-block;
  text-align: center;
  position: relative;
  width: 6.25%;
`;

export const ColumnTwo = styled.div`
  background: #DCDCDC;
  display: inline-block;
  text-align: center;
  position: relative;
  width: 12.50%;
`;

export const ColumnEight = styled.div`
  background: #DCDCDC;
  display: inline-block;
  text-align: center;
  position: relative;
  width: 50%;
`;

export const CardDiv = styled.div`
    margin-top: 10px;
    background: #DCDCDC;
    width: 100%;
    font-size: 0.6em;
    border-radius: 0px;
    float: none;
    height: 60px;
    color: black;
`;

export default NFTCard;
